module.exports = __webpack_public_path__ + "3dfa56dac2cc81752a1e67ec2100d017.png";